import React from 'react';

export default class SimpleNumberInput extends React.Component {
  constructor(props) {
    super(props);
    let extracts = ['-', 'e', '.'];
    if (this.props.allow) {
      extracts = extracts.filter((e) => this.props.allow.indexOf(e) === -1);
    }
    this.extractList = extracts;
  }

  cleanse = (e) => {
    const charCode = e.which || e.keyCode;
    const charStr = String.fromCharCode(charCode);
    if (this.extractList.includes(charStr)) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  render() {
    const { props } = this;
    const { allow: _allow, ...filteredProps } = props;
    return <input type="tel" {...filteredProps} onKeyPress={this.cleanse} />;
  }
}
